import { render, staticRenderFns } from "./NewsLetter.vue?vue&type=template&id=27c0ed1b&scoped=true&"
import script from "./NewsLetter.vue?vue&type=script&lang=js&"
export * from "./NewsLetter.vue?vue&type=script&lang=js&"
import style0 from "./NewsLetter.vue?vue&type=style&index=0&id=27c0ed1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c0ed1b",
  null
  
)

export default component.exports